import { Reveal } from "./Reveal";
import { MessageCircle, MapPin, GraduationCap, BadgeCheck } from "lucide-react";

export const MediatorProfile = () => (
  <section id="chi-sono" data-testid="mediator-profile" className="py-20 lg:py-32">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <Reveal className="lg:col-span-5">
        <div className="relative max-w-md mx-auto lg:mx-0">
          <div className="absolute -bottom-4 -right-4 w-full h-full arch-frame border border-gold/60 pointer-events-none" />
          <div className="arch-frame overflow-hidden bg-sand border border-ink/10 shadow-xl">
            <img
              src="/assets/valentina.jpg"
              alt="Dott.ssa Valentina Maritato, mediatrice familiare a Crotone"
              className="w-full h-[420px] lg:h-[500px] object-cover object-[50%_30%]"
              data-testid="mediator-portrait"
            />
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.15} className="lg:col-span-7">
        <p className="overline-tag mb-4">Chi sono</p>
        <h2 className="font-serif font-semibold text-ink tracking-tight text-2xl sm:text-3xl lg:text-4xl leading-tight">
          Dott.ssa Valentina Maritato
        </h2>
        <p className="mt-2 font-display text-xs sm:text-sm uppercase tracking-[0.2em] text-golddeep font-semibold">
          Mediatrice familiare · Crotone (KR)
        </p>

        <div className="mt-8 max-w-2xl">
          <p className="font-serif text-lg sm:text-xl text-ink/85 leading-relaxed">
            Ho imparato presto a tenere insieme le cose. Persone, sogni, progetti, attese.
            Lo faccio da sempre, senza fare rumore. Ho camminato accanto a chi cresce, a chi inciampa,
            a chi cerca. Da ognuno ho preso qualcosa, imparando il significato più profondo della
            gratitudine. Riconosco e accolgo i non detti, espressione massima di appartenenza e libertà.
            Ho attraversato cadute e ripartenze, raccolto frammenti che ho trasformato in cura.
            Scrivo molto, parlo piano, osservo a fondo. Adoro l'arte in ogni sua sfumatura, creare,
            accompagnare, esserci. Con la grazia che si impara quando la vita ti allena a stare.
            La mia formazione, i miei progetti, nascono così, da una visione che tiene insieme
            coraggio e delicatezza.
          </p>
          <p className="mt-6 font-serif italic text-2xl text-golddeep">Valentina</p>
        </div>

        <div className="mt-8 flex flex-wrap gap-3">
          {[
            { icon: GraduationCap, label: "Formazione specialistica in mediazione familiare" },
            { icon: MapPin, label: "Studio a Crotone, incontri anche online" },
            { icon: BadgeCheck, label: "Socia AIRAC", href: "https://airac.it", testid: "profile-airac-link" },
            { icon: BadgeCheck, label: "Camera di Mediazione Nazionale", href: "https://cameradimediazionenazionale.it", testid: "profile-cmn-link" },
          ].map(({ icon: Icon, label, href, testid }) =>
            href ? (
              <a key={label} href={href} target="_blank" rel="noopener noreferrer" data-testid={testid}
                className="inline-flex items-center gap-2 rounded-full border border-ink/15 bg-white px-4 py-2 text-sm text-ink/80 hover:border-gold hover:text-golddeep transition-colors duration-300">
                <Icon size={15} className="text-golddeep" /> {label}
              </a>
            ) : (
              <span key={label} className="inline-flex items-center gap-2 rounded-full border border-ink/15 bg-white px-4 py-2 text-sm text-ink/80">
                <Icon size={15} className="text-golddeep" /> {label}
              </span>
            )
          )}
        </div>

        <a href="https://wa.me/393296330445" target="_blank" rel="noopener noreferrer" data-testid="profile-whatsapp-cta"
          className="mt-9 inline-flex items-center gap-2 rounded-full bg-gold text-night font-semibold px-7 py-3.5 hover:bg-golddeep hover:text-paper hover:-translate-y-0.5 active:scale-95 transition-all duration-300">
          <MessageCircle size={17} /> Scrivimi su WhatsApp
        </a>
      </Reveal>
    </div>
  </section>
);
